unit SystemInvoiceNumberSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, WEBLib.DB;

type
  TfrmSystemInvoiceNumberSetup = class(TForm)
    WebPanel14: TPanel;
    WebLabel36: TLabel;
    WebLabel37: TLabel;
    edtPrefix: TDBEdit;
    edtNumber: TDBEdit;
    WebPanel1: TPanel;
    dsSystemNum: TDataSource;
    wcSystemNum: TXDataWebClient;
    WebPanel2: TPanel;
    wdsSystemNum: TXDataWebDataSet;
    wdsSystemNumTranType: TStringField;
    wdsSystemNumPrefix: TStringField;
    wdsSystemNumDescription: TStringField;
    wdsSystemNumSuffix: TIntegerField;
    lblTran: TLabel;
    WebButton1: TButton;
    WebButton2: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iState : integer;
    sTran : String;
  protected procedure LoadDFMValues; override; end;

var
  frmSystemInvoiceNumberSetup: TfrmSystemInvoiceNumberSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection , share.system.classes , share.common, search.TranType;

procedure TfrmSystemInvoiceNumberSetup.WebButton1Click(Sender: TObject);

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsSystemNum.Cancel;
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

begin
  case iState of
    1:  Begin
          //wcSystemNum.RawInvoke('IstfmsSystemService.Put_InvoiceNumber_Insert',[GetJsonFromDataSet(wdsSystemNum)],@OnSuccess, @OnError);
        End;
    2:  Begin
          wcSystemNum.RawInvoke('IstfmsSystemService.Put_InvoiceNumber_Edit',[GetJsonFromDataSet(wdsSystemNum)],@OnSuccess, @OnError);
        End;
  end;
end;

procedure TfrmSystemInvoiceNumberSetup.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmSystemInvoiceNumberSetup.WebFormShow(Sender: TObject);
  procedure OnResult(Response : TXDataClientResponse);
    Begin
      wdsSystemNum.Close;
      wdsSystemNum.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSystemNum.Open;

      if iState = 2 then
        begin
          wdsSystemNum.Edit;
        end;
    End;
begin

  case iState of
    1:  Begin
          wdsSystemNum.Open;
          wdsSystemNum.Insert;
        End;
    2:  Begin
          wcSystemNum.RawInvoke('IstfmsSystemService.Get_InvoiceNumbers_view',[0,sTran],@OnResult);
        End;
  end;

end;

procedure TfrmSystemInvoiceNumberSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel14 := TPanel.Create(Self);
  WebLabel36 := TLabel.Create(Self);
  WebLabel37 := TLabel.Create(Self);
  lblTran := TLabel.Create(Self);
  edtPrefix := TDBEdit.Create(Self);
  edtNumber := TDBEdit.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  dsSystemNum := TDataSource.Create(Self);
  wcSystemNum := TXDataWebClient.Create(Self);
  wdsSystemNum := TXDataWebDataSet.Create(Self);
  wdsSystemNumTranType := TStringField.Create(Self);
  wdsSystemNumPrefix := TStringField.Create(Self);
  wdsSystemNumDescription := TStringField.Create(Self);
  wdsSystemNumSuffix := TIntegerField.Create(Self);

  WebPanel14.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  lblTran.BeforeLoadDFMValues;
  edtPrefix.BeforeLoadDFMValues;
  edtNumber.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  dsSystemNum.BeforeLoadDFMValues;
  wcSystemNum.BeforeLoadDFMValues;
  wdsSystemNum.BeforeLoadDFMValues;
  wdsSystemNumTranType.BeforeLoadDFMValues;
  wdsSystemNumPrefix.BeforeLoadDFMValues;
  wdsSystemNumDescription.BeforeLoadDFMValues;
  wdsSystemNumSuffix.BeforeLoadDFMValues;
  try
    Name := 'frmSystemInvoiceNumberSetup';
    Width := 640;
    Height := 313;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel14.SetParentComponent(Self);
    WebPanel14.Name := 'WebPanel14';
    WebPanel14.Left := 0;
    WebPanel14.Top := 0;
    WebPanel14.Width := 640;
    WebPanel14.Height := 313;
    WebPanel14.Align := alClient;
    WebPanel14.ChildOrder := 2;
    WebPanel14.Color := clSilver;
    WebPanel14.TabOrder := 0;
    WebLabel36.SetParentComponent(WebPanel14);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 150;
    WebLabel36.Top := 96;
    WebLabel36.Width := 32;
    WebLabel36.Height := 15;
    WebLabel36.Caption := 'Prefix:';
    WebLabel36.HeightPercent := 100.000000000000000000;
    WebLabel36.WidthPercent := 100.000000000000000000;
    WebLabel37.SetParentComponent(WebPanel14);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 150;
    WebLabel37.Top := 162;
    WebLabel37.Width := 50;
    WebLabel37.Height := 15;
    WebLabel37.Caption := 'Number: ';
    WebLabel37.HeightPercent := 100.000000000000000000;
    WebLabel37.WidthPercent := 100.000000000000000000;
    lblTran.SetParentComponent(WebPanel14);
    lblTran.Name := 'lblTran';
    lblTran.Left := 488;
    lblTran.Top := 96;
    lblTran.Width := 3;
    lblTran.Height := 15;
    lblTran.HeightPercent := 100.000000000000000000;
    lblTran.WidthPercent := 100.000000000000000000;
    edtPrefix.SetParentComponent(WebPanel14);
    edtPrefix.Name := 'edtPrefix';
    edtPrefix.Left := 150;
    edtPrefix.Top := 117;
    edtPrefix.Width := 163;
    edtPrefix.Height := 22;
    edtPrefix.ChildOrder := 4;
    edtPrefix.HeightPercent := 100.000000000000000000;
    edtPrefix.WidthPercent := 100.000000000000000000;
    edtPrefix.DataField := 'Prefix';
    edtPrefix.DataSource := dsSystemNum;
    edtNumber.SetParentComponent(WebPanel14);
    edtNumber.Name := 'edtNumber';
    edtNumber.Left := 150;
    edtNumber.Top := 183;
    edtNumber.Width := 331;
    edtNumber.Height := 22;
    edtNumber.ChildOrder := 5;
    edtNumber.HeightPercent := 100.000000000000000000;
    edtNumber.WidthPercent := 100.000000000000000000;
    edtNumber.DataField := 'Suffix';
    edtNumber.DataSource := dsSystemNum;
    WebPanel1.SetParentComponent(WebPanel14);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 41;
    WebPanel1.Align := alTop;
    WebPanel1.Caption := 'System Number Setup';
    WebPanel1.ChildOrder := 8;
    WebPanel1.Color := clSilver;
    WebPanel1.Font.Charset := DEFAULT_CHARSET;
    WebPanel1.Font.Color := clWindowText;
    WebPanel1.Font.Height := -16;
    WebPanel1.Font.Name := 'Segoe UI';
    WebPanel1.Font.Style := [fsBold];
    WebPanel1.ParentFont := False;
    WebPanel1.TabOrder := 3;
    WebPanel2.SetParentComponent(WebPanel14);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 253;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alBottom;
    WebPanel2.ChildOrder := 9;
    WebPanel2.TabOrder := 2;
    WebButton1.SetParentComponent(WebPanel2);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 54;
    WebButton1.Top := 19;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Continue';
    WebButton1.Color := clGreenyellow;
    WebButton1.ChildOrder := 6;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel2);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 193;
    WebButton2.Top := 19;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 7;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    dsSystemNum.SetParentComponent(Self);
    dsSystemNum.Name := 'dsSystemNum';
    dsSystemNum.AutoEdit := False;
    dsSystemNum.DataSet := wdsSystemNum;
    dsSystemNum.Left := 264;
    dsSystemNum.Top := 40;
    wcSystemNum.SetParentComponent(Self);
    wcSystemNum.Name := 'wcSystemNum';
    wcSystemNum.Connection := dmData.dbConnect;
    wcSystemNum.Left := 120;
    wcSystemNum.Top := 40;
    wdsSystemNum.SetParentComponent(Self);
    wdsSystemNum.Name := 'wdsSystemNum';
    wdsSystemNum.Connection := dmData.dbConnect;
    wdsSystemNum.Left := 187;
    wdsSystemNum.Top := 40;
    wdsSystemNumTranType.SetParentComponent(wdsSystemNum);
    wdsSystemNumTranType.Name := 'wdsSystemNumTranType';
    wdsSystemNumTranType.FieldName := 'TranType';
    wdsSystemNumPrefix.SetParentComponent(wdsSystemNum);
    wdsSystemNumPrefix.Name := 'wdsSystemNumPrefix';
    wdsSystemNumPrefix.FieldName := 'Prefix';
    wdsSystemNumDescription.SetParentComponent(wdsSystemNum);
    wdsSystemNumDescription.Name := 'wdsSystemNumDescription';
    wdsSystemNumDescription.FieldName := 'Description';
    wdsSystemNumSuffix.SetParentComponent(wdsSystemNum);
    wdsSystemNumSuffix.Name := 'wdsSystemNumSuffix';
    wdsSystemNumSuffix.FieldName := 'Suffix';
  finally
    WebPanel14.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    lblTran.AfterLoadDFMValues;
    edtPrefix.AfterLoadDFMValues;
    edtNumber.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    dsSystemNum.AfterLoadDFMValues;
    wcSystemNum.AfterLoadDFMValues;
    wdsSystemNum.AfterLoadDFMValues;
    wdsSystemNumTranType.AfterLoadDFMValues;
    wdsSystemNumPrefix.AfterLoadDFMValues;
    wdsSystemNumDescription.AfterLoadDFMValues;
    wdsSystemNumSuffix.AfterLoadDFMValues;
  end;
end;

end.